/**
 * Created by fijas on 6/14/17.
 */
import {Injectable}    from '@angular/core';
import {environment} from '../../../environments/environment';

import {Search} from "../../utilities/events/Search";
import { HttpClient, HttpParams } from "@angular/common/http";
import {CommonService} from "./common.service";

@Injectable()
export class EventService {

    private eventsUrl: string;  // URL to web api

    constructor(private http: HttpClient, private commonService: CommonService) {
        this.eventsUrl = environment.apiBaseUrl + "events";
    }

    getEvents(page: number, searchModel: Search) {
        let params = new HttpParams()
            .set("page", page)
            .set("pageSize", "9")
            .set("term", searchModel.term);

        const convertedData = this.commonService.convertDataFromTree(searchModel);

        if(convertedData.countries.length > 0){ params = params.set('countries', convertedData.countries) }
        if(convertedData.industries.length > 0){ params = params.set('industries', convertedData.industries) }

        return this.http.get(this.eventsUrl, {params: params, observe: 'response' });
    }
}
